import { Skeleton } from "@/components/ui/skeleton";
import { SKELETONS, LAYOUTS, SPACING } from "@/design-system";
import { cn } from "@/lib/utils";

interface AdminContentSkeletonProps {
  tabCount?: number;
}

/**
 * Cold-start skeleton for admin/account pages.
 * Mirrors AdminLayout structure: pageAdmin → headerWrapper → headerContent + contentStack
 */
export function AdminContentSkeleton({ tabCount = 5 }: AdminContentSkeletonProps) {
  return (
    <div className={LAYOUTS.pageAdmin}>
      {/* Header - matches AdminLayout headerWrapper + headerContent */}
      <div className={cn(LAYOUTS.headerWrapper, SPACING.stackLg)}>
        <div className={LAYOUTS.headerContent}>
          {/* Title */}
          <Skeleton className={SKELETONS.elements.title.xl} />
          {/* Subtitle */}
          <Skeleton className={SKELETONS.elements.subtitle.lg} />
        </div>
      </div>
      {/* Content - matches AdminLayout contentStack */}
      <div className={LAYOUTS.contentStack}>
        {/* Tab bar */}
        <div className="inline-flex items-center gap-2 h-11 rounded-lg bg-muted/50 p-1">
          {Array.from({ length: tabCount }, (_, i) => (
            <Skeleton key={i} className="h-9 w-24 rounded-md" />
          ))}
        </div>
      </div>
    </div>
  );
}
